import { Skeleton } from '@/components/ui/skeleton';

interface CountBadgeProps {
  value: number;
  isLoading: boolean;
}

export function CountBadge({ value, isLoading }: CountBadgeProps) {
  return isLoading ? (
    <Skeleton className="my-1.5 ml-auto h-4 w-12 rounded-full" />
  ) : (
    <div className="bg-chariot-background-secondary ml-auto min-w-20 rounded-md px-3 py-1 text-center text-sm font-semibold tabular-nums">
      {value.toLocaleString()}
    </div>
  );
}
